export default __webpack_public_path__ + "i18n/translations/translation-kn.cf348a5d.json";